<template>
  <main
    id="application-content"
    class="container-fluid full-height-background"
  >
    <a
      class="skip-to-content"
      href="#application-main"
    >
      {{ $t('skip-to-main-content') }}
    </a>
    <header-component
      id="svp-head"
      class="row text-center menu-shadow"
      :existing-reward-link-exists="false"
    />
    <nav-banner />
    <article
      id="application-main"
      class="no-error-application-main"
    >
      <slot />
    </article>
    <footer-component
      id="footer"
      class="text-center"
      :existing-reward-link-exists="false"
    />
  </main>
</template>

<script>
import Footer from '../footer/Footer'
import Header from '../Header'
import NavBanner from '../NavBanner'

export default {
  name: 'NoExistingRewardLinkShell',
  components: {
    'header-component': Header,
    'footer-component': Footer,
    NavBanner
  },
  beforeMount () {
    const html = document.documentElement // returns the html tag
    html.setAttribute('lang', this.$i18n.locale)
  }
}
</script>

<style lang="scss">
@import '../../assets/css/global';

.full-height-background {
  height: 100%;
}

.visible-xs {
  display: none;
}

.hidden-xs {
  display: block;
}

@media screen and (max-width: $breakpoint-sm - 1) {
  .visible-xs {
    display: block;
  }

  .hidden-xs {
    display: none;
  }
}

.skip-to-content {
  padding: 1em;
  position: absolute;
  top: -40px;
  left: 1em;
  z-index: 1000;
  color: white;

  &:focus {
    position: absolute;
    top: 0;
    background: #EEEEEE;
  }
}
</style>
